// ============================================================================
// SaaS Analytics Service (Phase 3 backend aggregates)
// Store-wide aggregates that would need N client requests against
// hcp-admin-backend (per-member reviews, per-member RVs) are computed by
// hcp-saas over the campground DB, gated server-side by the Analysis
// subscription (403 when the category isn't in the plan).
// ============================================================================

import { authService } from './auth/authService';

const SAAS_API_URL = process.env.REACT_APP_SAAS_API_URL || 'http://localhost:8010';

export interface ReviewsSummary {
  monthly: Array<{ month: string; avg_rating: number; count: number }>;
  distribution: Array<{ rating: number; count: number }>;
  would_welcome_back_pct: number | null;
  total: number;
}

export interface RvDemographics {
  types: Array<{ type: string; count: number; avg_length: number | null }>;
  length_buckets: Array<{ label: string; count: number }>;
  total: number;
}

async function fetchAggregate<T>(path: string): Promise<T | null> {
  const corporateCode = authService.getCorporateCode();
  if (!corporateCode) return null;
  const response = await fetch(
    `${SAAS_API_URL}/api/public/analytics/${encodeURIComponent(corporateCode)}/${path}`
  );
  if (response.status === 403) return null; // not in the subscription tier
  if (!response.ok) {
    throw new Error(`Analytics aggregate failed (${response.status})`);
  }
  return response.json();
}

export function fetchReviewsSummary(): Promise<ReviewsSummary | null> {
  return fetchAggregate<ReviewsSummary>('reviews-summary');
}

export function fetchRvDemographics(): Promise<RvDemographics | null> {
  return fetchAggregate<RvDemographics>('rv-demographics');
}
